'use client';

import { useRouter, useSearchParams } from 'next/navigation';
import { useEffect, useState } from 'react';
import { isSupportedPlan } from 'types';
import { Box, Container, Loader } from 'ui';

import { OnboardingWizard } from './OnboardingWizard';

const BlenderLoader = () => (
  <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
    <Loader />
  </Box>
);

const RedirectToHome = () => {
  const router = useRouter();

  useEffect(() => {
    router.push('/home');
  }, [router]);

  return <BlenderLoader />;
};

export const OnboardingContainer = () => {
  const searchParams = useSearchParams();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  const plan = searchParams && searchParams.get('plan');

  useEffect(() => {
    if (typeof plan !== 'string' || !isSupportedPlan(plan)) {
      setShouldRedirect(true);
    }

    window.history.replaceState(window.history.state, '', '/onboarding');
  }, [plan]);

  return (
    <>
      {shouldRedirect && <RedirectToHome />}

      <Container sx={{ height: '100svh', padding: '0 !important' }} maxWidth={false}>
        <OnboardingWizard />
      </Container>
    </>
  );
};
